<template>
  <button
    class="tw-flex mod-util-ratio-16-9 tw-w-full tw-outline-none tw-relative tw-overflow-hidden game-tile-radius tw-border-3"
    @click="updateItem($event, index)"
    @keydown="handleKeyPress"
  >
    <div class="tw-absolute tw-top-0 tw-left-0 tw-size-full">
      <!-- sketchfab -->
      <template v-if="item?.type === 'sketchfab'">
        <img
          alt="Sketchfab thumbnail"
          :src="item.thumb"
          class="tw-size-full tw-object-cover tw-object-center tw-relative"
        />
        <div class="tw-absolute tw-inset-0 tw-bg-black/30">
          <div class="tw-absolute tw-left-0.5 tw-top-0.5 tw-size-6">
            <base-icon icon="sketchfab" class="tw-size-6 tw-fill-white" />
          </div>
        </div>
      </template>

      <!-- youtube -->
      <template v-if="item?.type === 'youtube'">
        <img
          alt="Youtube thumbnail"
          :src="`https://img.youtube.com/vi/${item.id}/0.jpg`"
          class="tw-size-full tw-object-cover tw-object-center tw-relative"
        />
        <div class="tw-absolute tw-inset-0 tw-bg-black/30">
          <div
            class="tw-absolute tw-left-0.5 tw-top-0.5 tw-size-6 tw-text-white"
          >
            <font-awesome-icon :icon="['fab', 'youtube']" size="2x" />
          </div>
        </div>
      </template>

      <!-- image -->
      <img
        v-else
        alt="Image thumbnail"
        class="tw-size-full tw-object-cover tw-object-center"
        :src="item.thumb || item.image"
      />
    </div>
  </button>
</template>

<script>
import { computed, toRefs } from 'vue'
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ['item:update', 'item:keydown'],
  setup(props, { emit }) {
    const { item } = toRefs(props)

    const showBgImage = computed(
      () => item.value.type === 'image' || item.value.type === 'sketchfab'
    )

    function updateItem(e, index) {
      e.currentTarget.focus()
      emit('item:update', index)
    }

    function handleKeyPress(e) {
      emit('item:keydown', e)
    }

    return {
      handleKeyPress,
      showBgImage,
      updateItem,
    }
  },
}
</script>
